import * as React from "react";
import { forwardRef } from "react";
const SvgSquareCrossed = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M1.023 0A1.01 1.01 0 0 0 .016 1.008v97.974a1.01 1.01 0 0 0 1.007 1.008H98.98a1.01 1.01 0 0 0 1.007-1.008V1.008A1.01 1.01 0 0 0 98.98 0zm2.434 2.016h93.088L50 48.568zM2.031 3.44l46.545 46.553L2.031 96.55zm95.94 0v93.11L51.426 49.994zM50 51.421l46.545 46.554H3.457z" />
  </svg>
);
const ForwardRef = forwardRef(SvgSquareCrossed);
export default ForwardRef;
